// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import logo from "../../Images/logo3.png";
// import "../Login.css";

// const AdminForgetPassword = () => {
//   const [email, setEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [serverOtp, setServerOtp] = useState("");
//   const [verifyOtp, setVerifyOtp] = useState(false);
//   const [newPassword, setNewPassword] = useState("");
//   const navigate = useNavigate();

//   const validateEmail = (email) =>
//     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   const handleSendOtp = async () => {
//     if (!validateEmail(email)) {
//       alert("Please enter a valid email");
//       return;
//     }

//     try {
      
//       const res = await axios.post("https://api.scannscore.com/admin-forget-password", { email });
//       alert("OTP sent successfully. Check your email!");
//       if (res.status === 200) {
//         const data = res.data;
//         setServerOtp(data.otp);
//         setOtpSent(true);
//       }
//     } catch (error) {
//       console.error(error);
//       if (error.response) {
//         alert(error.response.data.message || "Server error");
//       } else {
//         alert("Server error");
//       }
//     }
//   };

//   const handleVerifyOtp = () => {
//     if (!otp) {
//       alert("Please enter OTP");
//       return;
//     }
//     if (serverOtp === otp) {
//       alert("OTP verified successfully!");
//       setVerifyOtp(true);
//     } else {
//       alert("Invalid OTP");
//     }
//   };

//   const handleResetPassword = async () => {
//     if (newPassword.length < 6) {
//       alert("Password must be at least 6 characters");
//       return;
//     }

//     try {
     
//       await axios.post("https://api.scannscore.com/admin-reset-password", { email, newPassword });
//       alert("Password reset successfully!");
//       navigate("/");
//     } catch (error) {
//       console.error(error);
//       if (error.response) {
//         alert(error.response.data.message || "Server error");
//       } else {
//         alert("Server error");
//       }
//     }
//   };

//   return (
//     <div className="login-page">
//       <div className="col-lg-5 login-card rounded-5">
//         <div className="px-4 py-5">
//           <img
//             src={logo}
//             alt="logo"
//             className="d-block mx-auto mb-4 bg-white w-25 rounded-circle"
//           />
//           <h2 className="login-title text-center">Admin Forgot Password</h2>

//           {!otpSent && (
//             <>
//               <input
//                 type="email"
//                 className="login-input"
//                 placeholder="Enter your admin email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />
//               <button className="login-btn mt-3" onClick={handleSendOtp}>
//                 Send OTP
//               </button>
//             </>
//           )}

//           {otpSent && !verifyOtp && (
//             <>
//               <input
//                 type="text"
//                 className="login-input mt-3"
//                 placeholder="Enter OTP"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//               />
//               <button className="login-btn mt-3" onClick={handleVerifyOtp}>
//                 Verify OTP
//               </button>
//             </>
//           )}

//           {otpSent && verifyOtp && (
//             <>
//               <input
//                 type="password"
//                 className="login-input mt-3"
//                 placeholder="Enter new password"
//                 value={newPassword}
//                 onChange={(e) => setNewPassword(e.target.value)}
//               />
//               <button className="login-btn mt-3" onClick={handleResetPassword}>
//                 Reset Password
//               </button>
//             </>
//           )}
//         </div>

//         <div className="bottom-curve rounded-bottom-5">
//           <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/admin-login")}>
//             Back to Login
//           </h6>
        
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminForgetPassword;
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../../Images/logo3.png";
import "../Login.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdminForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [serverOtp, setServerOtp] = useState("");
  const [verifyOtp, setVerifyOtp] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const navigate = useNavigate();

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSendOtp = async () => {
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email");
      return;
    }

    try {
      const res = await axios.post("https://api.scannscore.com/admin-forget-password", { email });

      if (res.status === 200) {
        const data = res.data;
        setServerOtp(data.otp); 
        setOtpSent(true);
        toast.success("OTP sent successfully. Check your email!");
      }
    } catch (error) {
      console.error(error);
      if (error.response) {
        toast.error(error.response.data.message || "Server error");
      } else {
        toast.error("Server error");
      }
    }
  };

  const handleVerifyOtp = () => {
    if (!otp) {
      toast.error("Please enter OTP");
      return;
    }

    if (serverOtp === otp) {
      setVerifyOtp(true);
      toast.success("OTP verified successfully!");
    } else {
      toast.error("Invalid OTP");
    }
  };

  const handleResetPassword = async () => {
    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    try {
      await axios.post("https://api.scannscore.com/admin-reset-password", { email, newPassword });
      toast.success("Password reset successfully!");

     
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (error) {
      console.error(error);
      if (error.response) {
        toast.error(error.response.data.message || "Server error");
      } else {
        toast.error("Server error");
      }
    }
  };

  return (
    <div className="login-page">
      <div className="col-lg-5 login-card rounded-5">
        <div className="px-4 py-5">
          <img
            src={logo}
            alt="logo"
            className="d-block mx-auto mb-4 bg-white w-25 rounded-circle"
          />
          <h2 className="login-title text-center">Admin Forgot Password</h2>

          {!otpSent && (
            <>
              <input
                type="email"
                className="login-input"
                placeholder="Enter your admin email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="login-btn mt-3" onClick={handleSendOtp}>
                Send OTP
              </button>
            </>
          )}

          {otpSent && !verifyOtp && (
            <>
              <input
                type="text"
                className="login-input mt-3"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              <button className="login-btn mt-3" onClick={handleVerifyOtp}>
                Verify OTP
              </button>
            </>
          )}

          {otpSent && verifyOtp && (
            <>
              <input
                type="password"
                className="login-input mt-3"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <button className="login-btn mt-3" onClick={handleResetPassword}>
                Reset Password
              </button>
            </>
          )}
        </div>

        <div className="bottom-curve rounded-bottom-5">
          <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/admin-login")}>
            Back to Login
          </h6>
        </div>
      </div>


      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default AdminForgetPassword;